import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BModal } from "bootstrap-vue";
import { ref, watch } from "vue";
import ConfigurationTestSummary from "./ConfigurationTestSummary.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfigurationTestSummaryModal',
    props: {
        value: { type: Boolean },
        testResults: null,
        error: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const show = ref(props.value);
        watch(props, () => {
            show.value = props.value;
        });
        watch(show, () => {
            emit("input", show.value);
        });
        return { __sfc: true, props, show, emit, BAlert, BModal, ConfigurationTestSummary };
    }
});
